import moment from 'moment';
import * as React from 'react';
import { ExecuteBag } from '../Tables/KeywordTable/ToolbarButtons/AddKeywords/AddComboKeywords/EditComboRequestView/logic/useExecute';
import VoxelDialog from '../../voxel/Dialogs/VoxelDialog';
import VoxelDialogActionCancel from '../../voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../voxel/Dialogs/VoxelDialogContent';
import VoxelText from '../../voxel/Text/VoxelText';

export interface ComboExecuteDialogProps {
  executeBag: ExecuteBag;
}

const ComboExecuteDialog: React.FC<ComboExecuteDialogProps> = ({ executeBag }) => {
  return (
    <VoxelDialog
      title={`Request takes at least ${moment
        .duration(executeBag.wordCount.timeToExecuteMs)
        .humanize()}`}
      open={executeBag.executeDialog}
      onClose={executeBag.handleExecuteDialogClose}
    >
      <VoxelDialogContent>
        <VoxelText>
          No one else will be able to execute combo requests throughout that period.
        </VoxelText>
        <br></br>
        <br></br>
        <VoxelText>Do you wish to continue?</VoxelText>
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={executeBag.handleExecuteDialogClose} />
        <VoxelDialogActionSubmit
          onClick={executeBag.handleProcessRequest}
          title={'Execute'}
          disabled={executeBag.loading}
        />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default ComboExecuteDialog;
